import { CollectionListItem } from "@/components/observations/CollectionListItem"
import { useObservationForCollection } from "@/hooks/useObservationForCollection"
import { queryClient } from "@/lib/queryClient"
import { getCollectionsForProjectQueryOptions } from "@fieldbook/common/hooks"
import { CollectionWithDetermination } from "@fieldbook/common/types"
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@fieldbook/ui/alert-dialog"
import { createFileRoute, redirect } from "@tanstack/react-router"
import { EyeIcon, List } from "lucide-react"

export const Route = createFileRoute("/_private/projects/$id/scan/$tagCode")({
  component: RouteComponent,
  loader: async ({ params: { id: projectId, tagCode } }) => {
    let collection: CollectionWithDetermination | undefined
    try {
      const collections = await queryClient.ensureQueryData(
        getCollectionsForProjectQueryOptions(projectId),
      )
      collection = collections?.find((c) => c.nano_id === tagCode)
    } catch (e) {
      // noop
    }
    if (!collection)
      throw redirect({
        to: "/projects/$id/observations/new/collection",
        params: { id: projectId },
        search: { tagCode },
      })

    return { collection }
  },
})

function RouteComponent() {
  const nav = Route.useNavigate()
  const { collection } = Route.useLoaderData()
  const { tagCode } = Route.useParams()

  const { data: obs } = useObservationForCollection({
    collectionId: collection.id,
  })

  return (
    <AlertDialog open={true}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Tag {tagCode}</AlertDialogTitle>
          <AlertDialogDescription className="flex flex-col gap-2 text-lg"></AlertDialogDescription>
          {obs && (
            <CollectionListItem
              onClick={() =>
                nav({
                  to: "/projects/$id/data/observations/$observationId",
                  params: { observationId: obs.id },
                })
              }
              collection={collection}
              className="rounded-lg border"
            />
          )}
          <AlertDialogAction
            className="flex items-center gap-2"
            onClick={() =>
              nav({
                to: "/projects/$id/observations/new/existing",
                search: { collectionId: collection.id },
              })
            }
          >
            <EyeIcon size="15" />
            <span>Record New Observation</span>
          </AlertDialogAction>
          <AlertDialogAction
            className="border-primary bg-background flex items-center gap-2 border"
            onClick={() =>
              nav({
                to: "/projects/$id/data/observations",
                params: { id: obs?.project_id },
                search: { collectionId: collection.id },
              })
            }
          >
            <List size="15" />
            <span>View Observations</span>
          </AlertDialogAction>
          <AlertDialogCancel onClick={() => nav({ to: "/projects/$id" })}>
            Close
          </AlertDialogCancel>
        </AlertDialogHeader>
      </AlertDialogContent>
    </AlertDialog>
  )
}
